"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));
var _Theme = _interopRequireDefault(require("../../themes/Theme"));
var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));
var _DesktopView = _interopRequireDefault(require("../../elements/view/DesktopView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var NavLink = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs(function () {
  return {
    className: "d-flex justify-content-center align-items-center nav-link"
  };
}).withConfig({
  displayName: "IconNavigationNoSubLinks__NavLink",
  componentId: "hbnhqu-0"
})(["&&&{padding:5px 0.875rem;font-size:1.125rem;color:", ";width:68px;height:50px;&:hover{color:", ";}}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["grey"];
}).withComponent(function (_ref) {
  var isActive = _ref.isActive,
    props = _objectWithoutProperties(_ref, ["isActive"]);
  return _react["default"].createElement(_reactRouterDom.Link, props);
});
var MobileLink = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs(function () {
  return {
    className: "d-flex align-items-center nav-link"
  };
}).withConfig({
  displayName: "IconNavigationNoSubLinks__MobileLink",
  componentId: "hbnhqu-1"
})(["&&&{color:", ";&:hover{color:", ";}font-size:1.125rem;height:100%;padding:0.625rem 25px;background:", ";border-top:1px solid ", ";}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["mlb-secondary-blue"];
}, function (props) {
  return props.theme["black"];
});
var IconNavigationLinkNoSubLinks = function IconNavigationLinkNoSubLinks(_ref2) {
  var toggleMobileNav = _ref2.toggleMobileNav,
    to = _ref2.to,
    name = _ref2.name,
    icon = _ref2.icon;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_DesktopView["default"], null, _react["default"].createElement(NavLink, {
    onClick: function onClick() {
      if (toggleMobileNav) {
        toggleMobileNav(false);
      }
    },
    to: to
  }, _react["default"].createElement(_Icon["default"], {
    iconName: icon,
    styles: {
      color: _Theme["default"]["white"],
      hoverColor: _Theme["default"]["grey"]
    }
  }))), _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(MobileLink, {
    to: to,
    onClick: function onClick() {
      if (toggleMobileNav) {
        toggleMobileNav(false);
      }
    }
  }, _react["default"].createElement(_Icon["default"], {
    iconName: icon,
    styles: {
      color: _Theme["default"]["white"],
      hoverColor: _Theme["default"]["grey"]
    },
    className: "mr-3"
  }), name)));
};
IconNavigationLinkNoSubLinks.propTypes = {
  to: _propTypes["default"].string.isRequired,
  icon: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  toggleMobileNav: _propTypes["default"].bool.isRequired
};
var _default = IconNavigationLinkNoSubLinks;
exports["default"] = _default;